<template>
    <main :class="[className]">
        <transition name="view">
            <RouterView />
        </transition>

        <overlay v-if="showOverlay"></overlay>
    </main>
</template>
<script>
    export default {

        computed: {
            showOverlay: function() {
                return this.$store.state.showOverlay;
            },
            className: function(){
                return (this.$route.meta.class) ? this.$route.meta.class : '';
            }
        }
    }
</script>
<style>
    .view-enter-active, view-leave-active {
        transition: opacity 0.5s
    }
    .view-leave-active {
        position:absolute;
    }
    .view-enter, .view-leave-to {
        opacity:0;
    }
</style>